package com.klantenstop.web.pages.admin.categories

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.utils.MVI

interface CategoriesContract : MVI<CategoriesContract.State, CategoriesContract.Intent, CategoriesContract.Effect> {

    data class State(
        val categories: List<Category> = emptyList(),
        val isLoading: Boolean = false,
        val searchQuery: String = "",
        val categoryToDelete: Category? = null
    )

    sealed class Intent {
        data object LoadCategories : Intent()
        data class SearchCategories(val query: String) : Intent()
        data class DeleteCategory(val categoryId: String) : Intent()
        data class SetCategoryToDelete(val category: Category?) : Intent()
        data class NavigateToManage(val categoryId: String? = null) : Intent()
    }

    sealed class Effect {
        data class NavigateToManage(val categoryId: String? = null) : Effect()
        data class ShowError(val message: String) : Effect()
        data class ShowSuccess(val message: String) : Effect()
    }
}

